module.exports = __webpack_public_path__ + "img/Melbourne_Convention_Bureau_logo.a8c745d2.png";